import { render, staticRenderFns } from "./PubBreadcrumb.vue?vue&type=template&id=490f9aa1&scoped=true&"
import script from "./PubBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./PubBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./PubBreadcrumb.vue?vue&type=style&index=0&id=490f9aa1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f9aa1",
  null
  
)

export default component.exports